import styled from "styled-components";
import { Collapse } from "antd";
import { CaretRightOutlined } from "@ant-design/icons";
import WizrMarkDown from "../../../../../components/WizrMarkDown";
import WizrFlexLayout from "../../../../../components/WizrFlexLayout";
import WizrText from "../../../../../components/WizrText";

const { Panel } = Collapse;

const LogsContainer = styled.div`
  background: white;
  height: 100%;
  padding: 0;  // Remove top padding
  display: flex;
  flex-direction: column;

  padding: 8px;
  border-radius: 16px;

`;

const StyledCollapse = styled(Collapse)`
  background: white;
  border: none;
  

  
  .ant-collapse-item {
    border: none !important;
     background: #F9FAFA;  // Light grey background
    border-radius: 8px;   // Rounded corners
    margin-bottom: 8px;  // <-- Add this line for the white gap between questions
    
  }

  .ant-collapse-item:last-child {
    margin-bottom: 0; // No gap after the last item
  }

  .ant-collapse-header {
    padding: 16px 8px 8px 8px !important;
    align-items: center !important;
    
   
  }

  .ant-collapse-content {
  border: none;
    background: #F9FAFA;
  }

  .ant-collapse-content-box {
  padding: 0px 0px 16px 0px !important;
   
  }
`;

const PlayButton = styled.div`
  background: #4CAF50;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  .anticon {
    color: white;
    font-size: 12px;
  }
`;

const LogEntry = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 0;
`;

const LogTime = styled.span`
  color: #666;
  margin-left: auto;
`;

const CircleIcon = styled.div`
  background: #4CAF50;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  .anticon {
    color: white;
    font-size: 10px;
  }
`;

type ExpandIconProps = { isActive?: boolean };
const renderExpandIcon = ({ isActive }: ExpandIconProps) => (
  <CircleIcon>
    <CaretRightOutlined rotate={isActive ? 90 : 0} />
  </CircleIcon>
);

const ExpandedRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 0;
`;

const SupervisorLabel = styled.span`
  color: #5D5F62;
  font-size: 10px;
  margin-left: 8px;
  
  
`;

const Duration = styled.span`
  color: #666;
  margin-left: auto;
  margin-right: 16px;
 
 
`;




const Label = styled.div`
margin-top: 8px;
  color: #5D5F62;

 
`;

const Content = styled.div`
  color: #333;
  background: #F9FAFA;
  padding: 12px;
  border-radius: 4px;
`;

const ScrollableContent = styled.div`
  max-height: 200px;
  overflow-y: auto;
`;
const CenteredMessage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 72vh;
  width: 100%;
`;

const VerticalLine = styled.div<{ left?: string }>`
  position: absolute;
  left: ${({ left }) => left || '-16px'};
  top: 0;
  width: 6px;
  height: 100%;
  background: #DCDEE2;
  border-radius: 3px;
  z-index: 0;
`;

const getLogKey = (log: any): string => String(
  log?.log_id
  ?? log?.agent_invocation_time
  ?? `${log?.agent_name ?? ''}-${(log?.agent_input ?? '').length}-${(log?.agent_output ?? '').length}`
);

const getSupervisorKey = (log: any): string => `supervisor-${getLogKey(log)}`;

const getSubagentKey = (parentLog: any, subagent: any): string =>
  `sub-${getLogKey(parentLog)}-${subagent?.agent_invocation_time ?? subagent?.agent_name ?? (subagent?.agent_input ?? '').length}`;

const getToolKey = (subagent: any, tool: any): string =>
  `tool-sub-${subagent?.agent_invocation_time ?? subagent?.agent_name ?? ''}-${tool?.tool_invocation_time ?? tool?.tool_name ?? ''}`;

const getSupervisorToolKey = (log: any, tool: any): string =>
  `tool-sup-${getLogKey(log)}-${tool?.tool_invocation_time ?? tool?.tool_name ?? ''}`;

const Logs = ({ blockLevelHistory }: any) => {
    const { logs } = blockLevelHistory || {};

    if (!logs || logs.length === 0) {
        return (
            <CenteredMessage>
                <WizrText type='sub2' textColor='#1D1F22'>No Logs available</WizrText>
            </CenteredMessage>
        );
    }

    // Filter out FINISH agents from the logs
    const filteredLogs = logs.map((log: any) => ({
        ...log,
        subagent_invocation_details: log.subagent_invocation_details
            ? log.subagent_invocation_details.filter((subagent: any) => subagent.agent_name !== "FINISH")
            : [],
    }));

    return (
        <LogsContainer>
            <StyledCollapse
                expandIcon={renderExpandIcon}
                expandIconPosition="start"
            >
                {filteredLogs.map((log: any, index: number) => (
                    <Panel
                        header={
                            <LogEntry>
                                <WizrFlexLayout
                                    flexDirection="row"
                                    alignItems="center"
                                    background="transparent"
                                >
                                    <WizrText type="sub2" textColor="#1D1F22" style={{textAlign: 'left'}}>
                                        {log.agent_input || "N/A"}
                                    </WizrText>
                                </WizrFlexLayout>
                                <WizrText type="caption2" textColor="#5D5F62">
                                    {new Date(log.agent_invocation_time).toLocaleTimeString()}
                                </WizrText>
                            </LogEntry>
                        }
                        key={getLogKey(log)}
                    >
                        <StyledCollapse
                            expandIcon={renderExpandIcon}
                            expandIconPosition="start"
                        >
                            <Panel
                                header={
                                    <WizrFlexLayout flexDirection='row' alignItems='center' background='transparent' >
                                        <WizrText type='sub2' textColor='#1D1F22' style={{ textAlign: 'left' }}  >{log.agent_type || "Supervisor"}</WizrText>
                  
                                        <WizrFlexLayout flexDirection='row' alignItems='center' background='transparent' style={{marginLeft: 'auto'}}>
                                        <SupervisorLabel >{log.agent_name || "N/A"}</SupervisorLabel>
                                            
                                            <WizrText type="caption2" textColor="#5D5F62" style={{ marginLeft: 8, marginRight: 16 }}>
                                                {(log.duration / 1000).toFixed(2)}s
                                            </WizrText>
                                            <WizrText type="caption2" textColor="#5D5F62">
                                                {new Date(log.agent_invocation_time).toLocaleTimeString()}
                                            </WizrText>
                                        </WizrFlexLayout>
                                    </WizrFlexLayout>
                                }
                                key={getSupervisorKey(log)}
                                style={{ padding: '0px 0px 0px 8px', maxWidth: '100%', overflow: 'scroll' }}
                            >
                                <div style={{ position: 'relative', marginLeft: '24px' }}>
                                    <VerticalLine left="-12px" />
                                    {/* Supervisor Input and Output together */}
                                    <Label>Input</Label>
                                    <WizrMarkDown noMargin>{log.agent_input || "N/A"}</WizrMarkDown>
                                    <Label>Output</Label>
                                    <WizrMarkDown noMargin >{log.agent_output || "N/A"}</WizrMarkDown>

                                    {/* Subagents */}
                                    {log.subagent_invocation_details && log.subagent_invocation_details.length > 0 && (
                                        <StyledCollapse
                                            expandIcon={renderExpandIcon}
                                            expandIconPosition="start"
                                        >
                                            {log.subagent_invocation_details.map((subagent: any, subIndex: number) => (
                                                <Panel
                                                    header={
                                                        <WizrFlexLayout flexDirection='row' alignItems='center' background='transparent'>
                                                            <WizrText type='sub2' textColor='#1D1F22' style={{ textAlign: 'left' }}>
                                                                {subagent.agent_type || "subagent"}
                                                            </WizrText>
                                                            <WizrFlexLayout flexDirection='row' alignItems='center' background='transparent' style={{ marginLeft: 'auto' }}>
                                                                <SupervisorLabel>{subagent.agent_name || "N/A"}</SupervisorLabel>
                                                                <WizrText type="caption2" textColor="#5D5F62" style={{ marginLeft: 8, marginRight: 16 }}>
                                                                    {(subagent.duration / 1000).toFixed(2)}s
                                                                </WizrText>
                                                                <WizrText type="caption2" textColor="#5D5F62">
                                                                    {new Date(subagent.agent_invocation_time).toLocaleTimeString()}
                                                                </WizrText>
                                                            </WizrFlexLayout>
                                                        </WizrFlexLayout>
                                                    }
                                                    key={getSubagentKey(log, subagent)}
                                                >
                                                    <div style={{ position: 'relative', marginLeft: '32px' }}>
                                                        <VerticalLine left="-20px" />
                                                        {/* Subagent Input and Output together */}
                                                        <Label>Input</Label>
                                                        <WizrMarkDown noMargin>{subagent.agent_input || "N/A"}</WizrMarkDown>

                                                        <Label>Output</Label>
                                                        <WizrMarkDown noMargin>{subagent.agent_output || "N/A"}</WizrMarkDown>

                                                        {/* Tools */}
                                                        {subagent.tool_invocation_details && subagent.tool_invocation_details.length > 0 && (
                                                            <StyledCollapse
                                                                expandIcon={renderExpandIcon}
                                                                expandIconPosition="start"
                                                            >
                                                                {subagent.tool_invocation_details.map((tool: any, toolIndex: number) => (
                                                                    <Panel
                                                                        header={
                                                                            <WizrFlexLayout flexDirection='row' alignItems='center' background='transparent'>
                                                                                <WizrText type='sub2' textColor='#1D1F22'>TOOL</WizrText>
                                                                                <WizrFlexLayout flexDirection='row' alignItems='center' background='transparent' style={{ marginLeft: 'auto' }}>
                                                                                    <SupervisorLabel>{tool.tool_name || "N/A"}</SupervisorLabel>
                                                                                    <WizrText type="caption2" textColor="#5D5F62" style={{ marginLeft: 8, marginRight: 16 }}>
                                                                                        {(tool.duration / 1000).toFixed(2)}s
                                                                                    </WizrText>
                                                                                    <WizrText type="caption2" textColor="#5D5F62">
                                                                                        {new Date(tool.tool_invocation_time).toLocaleTimeString()}
                                                                                    </WizrText>
                                                                                </WizrFlexLayout>
                                                                            </WizrFlexLayout>
                                                                        }
                                                                        key={getToolKey(subagent, tool)}
                                                                    >
                                                                        <div style={{ position: 'relative', marginLeft: '40px' }}>
                                                                            <VerticalLine left="-24px" />
                                                                            {/* Tool Input and Output together */}
                                                                            <Label>Input</Label>
                                                                            {typeof tool.tool_input === 'object' ? (
                                                                                <pre style={{marginBottom: '0px'}}>{JSON.stringify(tool.tool_input, null, 2)}</pre>
                                                                            ) : (
                                                                                tool.tool_input || "N/A"
                                                                            )}

                                                                            <Label>Output</Label>
                                                                            <WizrMarkDown noMargin>
                                                                                {typeof tool.tool_output === 'object' 
                                                                                    ? "```json\n" + JSON.stringify(tool.tool_output, null, 2) + "\n```"
                                                                                    : tool.tool_output || "N/A"
                                                                                }
                                                                            </WizrMarkDown>
                                                                        </div>
                                                                    </Panel>
                                                                ))}
                                                            </StyledCollapse>
                                                        )}
                                                    </div>
                                                </Panel>
                                            ))}
                                        </StyledCollapse>
                                    )}

                                    {/* Supervisor Tools */}
                                    {log.tool_invocation_details && log.tool_invocation_details.length > 0 && (
                                        <StyledCollapse
                                            expandIcon={renderExpandIcon}
                                            expandIconPosition="start"
                                        >
                                            {log.tool_invocation_details.map((tool: any, toolIndex: number) => (
                                                <Panel
                                                    header={
                                                        <WizrFlexLayout flexDirection='row' alignItems='center' background='transparent'>
                                                            <WizrText type='sub2' textColor='#1D1F22'>TOOL</WizrText>
                                                            <WizrFlexLayout flexDirection='row' alignItems='center' background='transparent' style={{ marginLeft: 'auto' }}>
                                                                <SupervisorLabel>{tool.tool_name || "N/A"}</SupervisorLabel>
                                                                <WizrText type="caption2" textColor="#5D5F62" style={{ marginLeft: 8, marginRight: 16 }}>
                                                                    {(tool.duration / 1000).toFixed(2)}s
                                                                </WizrText>
                                                                <WizrText type="caption2" textColor="#5D5F62">
                                                                    {new Date(tool.tool_invocation_time).toLocaleTimeString()}
                                                                </WizrText>
                                                            </WizrFlexLayout>
                                                        </WizrFlexLayout>
                                                    }
                                                    key={getSupervisorToolKey(log, tool)}
                                                >
                                                    <div style={{ position: 'relative', marginLeft: '40px' }}>
                                                        <VerticalLine left="-15px" />
                                                        {/* Tool Input and Output together */}
                                                        <Label>Input</Label>
                                                        {typeof tool.tool_input === 'object' ? (
                                                            <pre>{JSON.stringify(tool.tool_input, null, 2)}</pre>
                                                        ) : (
                                                            tool.tool_input || "N/A"
                                                        )}

                                                        <Label>Output</Label>
                                                        <WizrMarkDown noMargin>
                                                            {typeof tool.tool_output === 'object' 
                                                                ? "```json\n" + JSON.stringify(tool.tool_output, null, 2) + "\n```"
                                                                : tool.tool_output || "N/A"
                                                            }
                                                        </WizrMarkDown>
                                                    </div>
                                                </Panel>
                                            ))}
                                        </StyledCollapse>
                                    )}
                                </div>
                            </Panel>
                        </StyledCollapse>
                    </Panel>
                ))}
            </StyledCollapse>
        </LogsContainer>
    );
};

export default Logs;